const updateMetaData = (field, key, newValue) => {
  let metaData = field.metaData;
  if (!newValue) {
    metaData = metaData.filter(({
      name
    }) => name !== key);
  } else {
    metaData = metaData.filter(({
      name
    }) => name !== key).concat([{
      name: key,
      value: newValue
    }]);
  }
  return Object.assign({}, field, {
    metaData
  });
};
export default updateMetaData;